import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as CargoDocCfmState from '@/class/cargo/model/parameters/CargoDocCfmState'
import * as ReleaseState from '@/class/cargo/model/parameters/ReleaseState'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { DocCommon } from '@/class/cargo/model/utils/DocCommon'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import { Company } from '@/class/model/mdm/Company'
import { Job } from '@/class/model/booking/Job'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { StatusChangeHistory } from '@/class/model/booking/StatusChangeHistory'
import { CheckCargoDocHistory } from '@/class/model/booking/CheckCargoDocHistory'
import { isArray } from '@/utils/validate'
import StrUtils from '@/utils/StrUtils'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as BlModeType from '@/class/cargo/model/parameters/BlModeType'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import $store from '@/store'
import { DOC_PAGE_SOURCE } from '@/class/cargo/model/parameters/SystemConstants'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export class TabMBLPM extends AbstractViewManage {
  /**
 * @param {Object} view 视图
 */
  constructor(view) {
    super(view)
    this.view = view
    this.useMscEDICarriers = '' // 开启Msc EDI信息的船公司(','符号分割的键值对，key-scac code,value-是否开启)
    this.printParam4Type = [
      { label: '', data: '' },
      { label: 'AS CARRIER', data: 'AS CARRIER' },
      { label: 'AS AGENT FOR THE CARRIER', data: 'AS AGENT FOR THE CARRIER' },
      { label: 'AS AGENT FOR ', data: 'AS AGENT FOR ' }
    ]
    this.otherField = 'alsoNotify'
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = false // 是否同步收发通代码到基本页签
    this._valueType = undefined
    this._editWindow = null
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get packingList() {
    return this.view.context.packingList
  }
  set packingList(packingList) {
    // 不可赋值
  }
  get user() {
    return this.context.user
  }
  set user(user) {
    // 不可赋值
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    // 不可赋值
  }
  get isCarrierUserMSC() {
    return this.view.isCarrierUserMSC
  }
  set isCarrierUserMSC(isCarrierUserMSC) {
    this.view.isCarrierUserMSC = isCarrierUserMSC
  }
  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }
  get form() {
    return this.view.form
  }
  set form(form) {
    this.addrPM = new BillAddressCommonPM(this.view)
    this.addrPM.job = this.job
    this.view.form = form
  }
  get addrPM() {
    return this.view.addrPM
  }
  set addrPM(addrPM) {
    this.view.addrPM = addrPM
  }
  init() {
    this.useMscEDICarriers = this.config.get('useMSCEDI')
    this.view.maxChars = Number(this.config.get('SIShipperConsigneNotifyMaxchars')) || 45
    this.view.warningCount = Number(this.config.get('SIShipperConsigneNotifyWarningColor')) || 35
    // 从配置中读取英文品名最大字符数
    const maxChars = Number(this.config.get('SEEnglishDescriptionOfGoodsMaxchars'))
    if (maxChars > 0) {
      this.view.englishNameMaxChars = maxChars
    }
    // 从配置中读取唛头最大字符数
    const maxChars2 = Number(this.config.get('SEMarkMaxChars'))
    if (maxChars2 > 0) {
      this.view.markMaxChars = maxChars2
    }
    // 从配置中读取海运出口MBL英文品名标红字符数
    const maxColor = Number(this.config.get('SEEnglishDescriptionOfGoodWarningColor'))
    if (maxColor > 0) {
      this.view.englishNameWarningCount = maxColor
    }
    // 从配置中读取海运出口MBL唛头标红字符数
    const maxColor2 = Number(this.config.get('SEMarkWarningColor'))
    if (maxColor2 > 0) {
      this.view.markWarningCount = maxColor2
    }
    getSpecificBasicData(basicCacheKeys.basic_data_PaymentTerm).then(data => {
      this.paymentTermList = data
    })
    getSpecificBasicData(basicCacheKeys.basic_data_BlMode).then(data => {
      const serialNumbers = this.view.blModeList.map(bm => bm.serialNumber)
      for (const item of data) {
        if (item.blType === BlModeType.MBL.code && !serialNumbers.includes(item.serialNumber)) {
          this.view.blModeList.push(item)
        }
      }
    })
    getSpecificBasicData(basicCacheKeys.basic_data_Packing).then(data => {
      this.packingList = data
    })
  }
  async changeJob() {
    const job = new SeaImportJob(this.job)
    const cargoDoc = await job.getSeaCargoDoc()
    await this.loadCargoDoc2Handler(cargoDoc)
    await this.loadJointSlaves2Handler()
    this.job.typeMBL = this.job.typeMBL || 1
    this.refreshVessel()
  }
  async fillView() {
    this.carrierIsOpenMscEDI()
    this.initOtherField()
    this.resetColor()
    if (this.form.cfmState === 3) {
      await this.loadCheckDocs()
    }
  }
  /**
   * 获取最近修改的对单记录
   */
  async loadCheckDocs() {
    const checkDocHistories = await CheckCargoDocHistory.queryDocHistoryByTime(this.form.uuid)
    this.queryTopCheckDocHistoriesHandler(checkDocHistories)
  }
  queryTopCheckDocHistoriesHandler(checkDocHistories) {
    this.comparedCargoDocIsModified(checkDocHistories)
  }
  /**
   * 对单后把有修改的内容显示红色
   */
  comparedCargoDocIsModified(checkDocHistories) {
    if (checkDocHistories && checkDocHistories.length > 0) {
      const variableCss = this.view.variableCss
      // 获取对单记录的第一条记录，根据是否有标识字段判断是否对单时修改了字段,有字段修改的情况去改变字段颜色
      const firstCheckDaoHistory = checkDocHistories[0]
      if (firstCheckDaoHistory.fieldName !== 'noChange') {
        for (const checkDocHistory of checkDocHistories) {
          const fieldName = checkDocHistory.fieldName
          if (variableCss.hasOwnProperty(fieldName)) {
            if (fieldName === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
              continue
            } else if (fieldName === 'mark' && this.form.mark.length >= 22) {
              continue
            }
            this.checkHistoryTextMapChanged(checkDocHistory, checkDocHistories)
          }
        }
      }
    }
  }
  /**
   * 对单内容
   */
  checkHistoryTextMapChanged(checkDocHistory, checkDocHistories) {
    switch (checkDocHistory.fieldName) {
      case 'shipperLine':
        this.checkHistoryByShipperConsigneeNotifyLine('shipperLineOld', 'shipperLine', checkDocHistory, checkDocHistories)
        break
      case 'consigneeLine':
        this.checkHistoryByShipperConsigneeNotifyLine('consigneeLineOld', 'consigneeLine', checkDocHistory, checkDocHistories)
        break
      case 'notifyLine':
        this.checkHistoryByShipperConsigneeNotifyLine('notifyLineOld', 'notifyLine', checkDocHistory, checkDocHistories)
        break
      default:
        this.view.variableCss[checkDocHistory.fieldName] = 'red'
        break
    }
  }
  /**
   * 检查收发通知人是否发生变化
   */
  checkHistoryByShipperConsigneeNotifyLine(oldField, textField, checkDocHistory, checkDocHistories) {
    const line = checkDocHistory.fieldValue
    const oldLine = this.getDocHistoryShipperConsigneeNotify(oldField, checkDocHistories)
    const lines = line.split('|')
    const oldLines = oldLine.split('|')
    for (let i = 0; i < lines.length; ++i) {
      const index = i + 1
      const line2 = lines[i].replace('\r\n', '')
      const lineOld2 = oldLines[i].replace('\r\n', '')
      if (line2 !== lineOld2) {
        this.view.variableCss[textField + index] = 'red'
      }
    }
  }
  /**
   * 获取上一个版本收发通历史的数据
   */
  getDocHistoryShipperConsigneeNotify(fieldName, checkDocHistories) {
    for (var history in checkDocHistories) {
      if (history.fieldName === fieldName) {
        return history.fieldValue
      }
    }
    return ''
  }
  /**
   * 重置对单颜色
   */
  resetColor() {
    for (const key in this.view.variableCss) {
      if (key === 'cargoEnglishName' && this.form.cargoEnglishName.length >= 45) {
        continue
      } else if (key === 'mark' && this.form.mark.length >= 22) {
        continue
      }
      this.view.variableCss[key] = ''
    }
  }
  fillModel() {
    this.form.containerSum = ContainerUtil.getSeaeqNumberStr(this.job)
    // 提单发货地
    this.form.dispatchingPlace = this.toUpperCase(this.form.dispatchingPlace)
    // 提单起运港
    this.form.loadingPort = this.toUpperCase(this.form.loadingPort)
    // 提单卸货港
    this.form.dischargingPort = this.toUpperCase(this.form.dischargingPort)
    // 提单目的港
    this.form.destinationPort = this.toUpperCase(this.form.destinationPort)
    // 提单目的地
    this.form.destinationPlace = this.toUpperCase(this.form.destinationPlace)
    // 提单备注
    this.form.remarks = this.toUpperCase(this.form.remarks)
    // 箱重大写
    this.form.signPlaceBL = this.toUpperCase(this.form.signPlaceBL)
    // 英文品名
    // this.form.cargoEnglishName = this.toUpperCase(this.form.cargoEnglishName)
    // 唛头
    // this.form.mark = this.toUpperCase(this.form.mark)
    this.form.state = this.form.state || 1
    this.form.alsoNotify = this.toUpperCase(this.form.alsoNotify)
    this.form.cargoManifestName = this.toUpperCase(this.form.cargoManifestName)
    this.form[this.otherField + 'Code'] = this.view.otherCode
  }
  toUpperCase(content) {
    return content ? content.toUpperCase() : ''
  }
  print() {
    // if (view.job) {
    //   var params: Object = new Object()
    //   params.jobuuid = view.job.key
    //   params.cargoDocUuid = view.cargoDoc.key
    //   params.DOC_UUID = view.cargoDoc.key
    //   TemplateSelectorWin.getInstance().showThisWin(view.job, 'MBL', params, view, null, printedCallback, v2CheckCallbackFun)
    // }
  }
  /**
   * V1打印反馈
   */
  printedCallback(evt = null) {
    // Tracking.updateTrackingByEvent(view.job.key, TrackingConstants.TRIGGER_PRINT_MBL.code, new mx.rpc.Responder(function (e) { }, view.faultHandler))
  }
  /**
   * V2打印反馈
   */
  v2CheckCallbackFun(printed, template, entity, params) {
    // if (printed) {
    //   printedCallback()
    // }
  }
  async executeTask() {
    DocCommon.MBL_History.shipperLine1 = this.form.shipperLine1
    DocCommon.MBL_History.shipperLine2 = this.form.shipperLine2
    DocCommon.MBL_History.shipperLine3 = this.form.shipperLine3
    DocCommon.MBL_History.shipperLine4 = this.form.shipperLine4
    DocCommon.MBL_History.shipperLine5 = this.form.shipperLine5
    DocCommon.MBL_History.shipperLine6 = this.form.shipperLine6
    DocCommon.MBL_History.shipperCode = this.form.shipperCode
    DocCommon.MBL_History.consigneeLine1 = this.form.consigneeLine1
    DocCommon.MBL_History.consigneeLine2 = this.form.consigneeLine2
    DocCommon.MBL_History.consigneeLine3 = this.form.consigneeLine3
    DocCommon.MBL_History.consigneeLine4 = this.form.consigneeLine4
    DocCommon.MBL_History.consigneeLine5 = this.form.consigneeLine5
    DocCommon.MBL_History.consigneeLine6 = this.form.consigneeLine6
    DocCommon.MBL_History.consigneeCode = this.form.consigneeCode
    DocCommon.MBL_History.notifyLine1 = this.form.notifyLine1
    DocCommon.MBL_History.notifyLine2 = this.form.notifyLine2
    DocCommon.MBL_History.notifyLine3 = this.form.notifyLine3
    DocCommon.MBL_History.notifyLine4 = this.form.notifyLine4
    DocCommon.MBL_History.notifyLine5 = this.form.notifyLine5
    DocCommon.MBL_History.notifyLine6 = this.form.notifyLine6
    DocCommon.MBL_History.notifyCode = this.form.notifyCode
    DocCommon.MBL_History.dgconsignLine1 = this.form.dgconsignLine1
    DocCommon.MBL_History.dgconsignLine2 = this.form.dgconsignLine2
    DocCommon.MBL_History.dgconsignLine3 = this.form.dgconsignLine3
    DocCommon.MBL_History.dgconsignLine4 = this.form.dgconsignLine4
    DocCommon.MBL_History.dgconsignLine5 = this.form.dgconsignLine5
    DocCommon.MBL_History.dgconsignLine6 = this.form.dgconsignLine6
    DocCommon.MBL_History.elseInvoiceLine1 = this.form.elseInvoiceLine1
    DocCommon.MBL_History.elseInvoiceLine2 = this.form.elseInvoiceLine2
    DocCommon.MBL_History.elseInvoiceLine3 = this.form.elseInvoiceLine3
    DocCommon.MBL_History.elseInvoiceLine4 = this.form.elseInvoiceLine4
    DocCommon.MBL_History.elseInvoiceLine5 = this.form.elseInvoiceLine5
    DocCommon.MBL_History.elseInvoiceLine6 = this.form.elseInvoiceLine6
    DocCommon.MBL_History.englishCargoName = this.form.cargoEnglishName
    DocCommon.MBL_History.mark = this.form.mark
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      await this.addrPM.saveCheck()
    }
    // 同步主票提单信息
    if (this.job && this.job.uuid && this.job.masterFlag) {
      const cargoDoc = await new SeaImportJob(this.job).getSeaCargoDoc()
      await this.loadCargoDoc2Handler(cargoDoc)
    }
  }
  async loadCargoDoc2Handler(cargoDocList) {
    if (!cargoDocList) {
      cargoDocList = await new SeaImportJob(this.job).getSeaCargoDoc()
    }
    this.form = null
    if (cargoDocList.length > 0) {
      for (const doc1 of cargoDocList) {
        if (doc1.docType === 'MBL') {
          this.form = doc1
          break
        }
      }
      if (this.job.typeMBL === 2) {
        for (const doc2 of cargoDocList) {
          if (doc2.docType === 'MBL2') {
            this.cmbtypeMBLDisabled = true
            break
          }
        }
      }
    }
    if (!this.form) {
      this.form = new SeaImCargoDoc().fillDefaultValue().getData()
      await SeaImCargoDoc.copyInfoFromSeaImportJob(this.job, this.form)
      this.form.docType = 'MBL'
      this.form.edi = true
      this.form.jobUuid = this.job.uuid
      cargoDocList.push(this.form)
    } else {
      if (this.form.pageSource === DOC_PAGE_SOURCE) {
        // 暂时不用 copyInfoFromSeaExportJob
        await SeaCargoDoc.copyInfoFromJobPort(this.job, this.form)
        this.form.signPlaceBL = this.job.signPlaceBL
      }
    }
    if (!this.form.uuid) {
      this.form.edi = true
    }
    await this.editingChanged()
    this.showScac()
    this.getDocCfmState()
  }
  /**
   * 编辑修改
   */
  async loadJointSlaves2Handler() {
    const job = new SeaImportJob(this.job)
    const jointSlavesMBL = await job.getJointSlavesMBL()
    console.log('===', jointSlavesMBL)
    if (jointSlavesMBL && jointSlavesMBL.length > 0) {
      this.view.cmbtypeMBLDisabled = true
    } else {
      this.view.cmbtypeMBLDisabled = !this.view.isEdit
    }
  }
  /**
   * change printParam6
   */
  printParam6Change() {
    this.refreshVessel()
  }

  eDIChange() {
    // // todo-shengsheng  Desc: cargo好像没相关监听
    // this.$emit('refreshJob')
  }
  onCopy1() {
    this.form.shipperCode = DocCommon.MBL_History.shipperCode || ''
    this.form.shipperLine1 = DocCommon.MBL_History.shipperLine1 || ''
    this.form.shipperLine2 = DocCommon.MBL_History.shipperLine2 || ''
    this.form.shipperLine3 = DocCommon.MBL_History.shipperLine3 || ''
    this.form.shipperLine4 = DocCommon.MBL_History.shipperLine4 || ''
    this.form.shipperLine5 = DocCommon.MBL_History.shipperLine5 || ''
    this.form.shipperLine6 = DocCommon.MBL_History.shipperLine6 || ''
    this.form.consigneeCode = DocCommon.MBL_History.consigneeCode || ''
    this.form.consigneeLine1 = DocCommon.MBL_History.consigneeLine1 || ''
    this.form.consigneeLine2 = DocCommon.MBL_History.consigneeLine2 || ''
    this.form.consigneeLine3 = DocCommon.MBL_History.consigneeLine3 || ''
    this.form.consigneeLine4 = DocCommon.MBL_History.consigneeLine4 || ''
    this.form.consigneeLine5 = DocCommon.MBL_History.consigneeLine5 || ''
    this.form.consigneeLine6 = DocCommon.MBL_History.consigneeLine6 || ''
    this.form.notifyCode = DocCommon.MBL_History.notifyCode || ''
    this.form.notifyLine1 = DocCommon.MBL_History.notifyLine1 || ''
    this.form.notifyLine2 = DocCommon.MBL_History.notifyLine2 || ''
    this.form.notifyLine3 = DocCommon.MBL_History.notifyLine3 || ''
    this.form.notifyLine4 = DocCommon.MBL_History.notifyLine4 || ''
    this.form.notifyLine5 = DocCommon.MBL_History.notifyLine5 || ''
    this.form.notifyLine6 = DocCommon.MBL_History.notifyLine6 || ''
    this.form.cargoEnglishName = DocCommon.MBL_History.englishCargoName || ''
    this.form.mark = DocCommon.MBL_History.mark || ''
  }
  selectionItemHandler(rows) {
    const selectedMBL = isArray(rows) ? rows[0] : rows
    if (selectedMBL) {
      this.form.shipperCode = selectedMBL.shipperCode
      this.form.shipperLine1 = selectedMBL.shipperLine1
      this.form.shipperLine2 = selectedMBL.shipperLine2
      this.form.shipperLine3 = selectedMBL.shipperLine3
      this.form.shipperLine4 = selectedMBL.shipperLine4
      this.form.shipperLine5 = selectedMBL.shipperLine5
      this.form.shipperLine6 = selectedMBL.shipperLine6
      this.form.consigneeCode = selectedMBL.consigneeCode
      this.form.consigneeLine1 = selectedMBL.consigneeLine1
      this.form.consigneeLine2 = selectedMBL.consigneeLine2
      this.form.consigneeLine3 = selectedMBL.consigneeLine3
      this.form.consigneeLine4 = selectedMBL.consigneeLine4
      this.form.consigneeLine5 = selectedMBL.consigneeLine5
      this.form.consigneeLine6 = selectedMBL.consigneeLine6
      this.form.notifyCode = selectedMBL.notifyCode
      this.form.notifyLine1 = selectedMBL.notifyLine1
      this.form.notifyLine2 = selectedMBL.notifyLine2
      this.form.notifyLine3 = selectedMBL.notifyLine3
      this.form.notifyLine4 = selectedMBL.notifyLine4
      this.form.notifyLine5 = selectedMBL.notifyLine5
      this.form.notifyLine6 = selectedMBL.notifyLine6
      this.form.cargoEnglishName = this.job.cargoEnglishName
      this.form.mark = this.job.mark
      // LogStores.sendFunctionClickLogStoresByLabel('海运出口-MBL-单号抄录-收发通选择')
    }
  }
  /**
   * 抄录MBL
   */
  async onCopyHBL() {
    const hdoc = await new SeaImportJob(this.job).getMainHbl(false)
    if (hdoc) {
      this.form.cargoEnglishName = hdoc.cargoEnglishName
      this.form.mark = hdoc.mark
    }
  }
  /**
   * 提单类型
   */
  cmbtypeMBLChangeHandler(value) {
    const job = this.job
    const mbl2Types = [BillType.SPLIT_BILL_TYPE.code, BillType.MERGE_BILL_TYPE.code]
    if (mbl2Types.includes(job.typeMBL) && mbl2Types.includes(value) && job.typeMBL !== value) {
      this.view.$emit('resetTab', 'tabMBL2')
    }

    if (mbl2Types.includes(job.typeMBL) && job.typeMBL !== value) {
      const cargoDocArr = this.job.seaCargoDoc
      for (let i = cargoDocArr.length - 1; i >= 0; --i) {
        const item = cargoDocArr[i]
        if (item.docType === CargoDocConsts.MBL2) {
          item.deleted = true
          this.addCargoDocToModifiedSet(item)
          cargoDocArr.splice(i, 1)
        }
      }
    }
    job.typeMBL = value
  }
  // 添加cargoDoc到被修改的集合中
  addCargoDocToModifiedSet(item) {
    const modifiedData = this.context.modifiedData
    modifiedData.seaCargoDoc = modifiedData.seaCargoDoc || []
    const oldItem = modifiedData.seaCargoDoc.find(p => p === item)
    if (oldItem) {
      Object.assign(oldItem, item)
    } else {
      modifiedData.seaCargoDoc.push(item)
    }
  }
  /**
   * 提单种类
   */
  cmbreleaseTypeMBLChangeHandler(value) {
    this.form.blNumber = Number(value) === 1 ? 'THREE' : 'ONE'
  }
  /**
   * 抄录收货人
   */
  onCopyConsignee() {
    this.form.notifyCode = this.form.consigneeCode
    this.form.notifyLine1 = this.form.consigneeLine1
    this.form.notifyLine2 = this.form.consigneeLine2
    this.form.notifyLine3 = this.form.consigneeLine3
    this.form.notifyLine4 = this.form.consigneeLine4
    this.form.notifyLine5 = this.form.consigneeLine5
    this.form.notifyLine6 = this.form.consigneeLine6
    this.form.notifyLine7 = this.form.consigneeLine7
  }
  replaceAll(source, find, replacement) {
    // return source.split(find).join(replacement)
  }
  refreshEDIFields() {
    // view.cargoDoc[_valueType + 'Contact'] = _editWindow.contact
    // view.cargoDoc[_valueType + 'Mobile'] = _editWindow.mobile
    // view.cargoDoc[_valueType + 'Fax'] = _editWindow.fax
    // view.cargoDoc[_valueType + 'Email'] = _editWindow.email
    // view.cargoDoc[_valueType + 'ZipCode'] = _editWindow.zipCode
    // view.cargoDoc[_valueType + 'City'] = _editWindow.city
    // _valueType = ''
  }
  validate6Line(s) {
    return true
  }
  /**
   * 清空收发通
   */
  onClear(type) {
    switch (type) {
      case 1:
        this.form.shipperCode = ''
        this.form.shipperLine1 = ''
        this.form.shipperLine2 = ''
        this.form.shipperLine3 = ''
        this.form.shipperLine4 = ''
        this.form.shipperLine5 = ''
        this.form.shipperLine6 = ''
        this.form.shipperLine7 = ''
        break
      case 2:
        this.form.consigneeCode = ''
        this.form.consigneeLine1 = ''
        this.form.consigneeLine2 = ''
        this.form.consigneeLine3 = ''
        this.form.consigneeLine4 = ''
        this.form.consigneeLine5 = ''
        this.form.consigneeLine6 = ''
        this.form.consigneeLine7 = ''
        break
      case 3:
        this.form.notifyCode = ''
        this.form.notifyLine1 = ''
        this.form.notifyLine2 = ''
        this.form.notifyLine3 = ''
        this.form.notifyLine4 = ''
        this.form.notifyLine5 = ''
        this.form.notifyLine6 = ''
        this.form.notifyLine7 = ''
        break
      default:
        break
    }
  }
  /**
   * CopyEnglishDescriptionOfGoodsFromReceipt
   */
  async getSlavesHBLEnglishName() {
    const list = await Job.getSlavesHBLEnglishName(this.job.uuid)
    if (list.length > 0) {
      this.form.cargoEnglishName = list.join('\n\r')
    }
  }
  /**
   * 取小票唛头
   */
  async getSlavesHBLMark() {
    const list = await Job.getSlavesHBLMark(this.job.uuid)
    if (list.length > 0) {
      this.form.mark = list.join('\n\r')
    }
  }
  /**
   * 取HBL信息
   */
  async getHBLInfo(type) {
    await new SeaImportJob(this.job).getSeaCargoDoc()
    let mbl = null
    for (const doc of this.job.seaCargoDoc) {
      if (doc.docType === 'HBL') {
        mbl = doc
        break
      }
    }
    if (mbl) {
      if (type === 'mark') {
        this.form.mark = mbl.mark
      } else if (type === 'EName') {
        this.form.cargoEnglishName = mbl.cargoEnglishName
      }
    }
  }
  initOtherField() {
    const otherFieldsData = []
    otherFieldsData.push(SeaExportConstants.ALSO_NOTIFY)
    if (this.job.cargoType === 'DG') {
      otherFieldsData.push(SeaExportConstants.DGCONSIGN)
    }
    const paymentTermMblName = this.getPaymentTermNameByCode(this.job.paymentTermMBL)
    const isContainerElseWhere = paymentTermMblName && paymentTermMblName.toUpperCase().includes('ELSEWHERE')
    if (isContainerElseWhere) {
      otherFieldsData.push(SeaExportConstants.ELSE_INVOICE)
    }
    this.view.otherFieldsData = otherFieldsData
    this.view.otherField = otherFieldsData[0].code
    this.otherInfoChangeHandler(this.view.otherField)
  }
  getPaymentTermNameByCode(code) {
    if (this.paymentTermList) {
      const paymentTerm = this.paymentTermList.find(p => p.code === code)
      if (paymentTerm) {
        return paymentTerm.name
      }
    }
    return code
  }
  txtMarkChangeHandler(e) {
    if (!this.view.isEdit) return
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.form)
  }
  txtCargoEnglishNameChangeHandler() {
    if (!this.view.isEdit) return
    SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.form)
  }
  /**
   * ex excel
   */
  exportToExcel() {
    const jobNo = this.job.jobNo
    const cpy = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    if (cpy) {
      const isMasterJob = this.job.masterFlag && this.job.containerLoadType === 'LCL'
      // todo-shengsheng  Desc: excel调用处待实现
      ExportUtils.exportToExcelByJobNo('SeaImportJob', cpy.shortName, jobNo, isMasterJob, 'BILL_' + jobNo)
    } else {
      this.view.$message.info(this.view.$t('Message.NoTargetShippingCompanyFoundHerePleaseRefreshTheCache'))
    }
  }
  async getCfmBillAddressHandler(event = null) {
    await new SeaImportJob(this.job).getSeaCargoDoc()
    this.reloadCargoDocHandler()
  }
  async confirmResultHandler(event) {
    await new StatusChangeHistory({
      statusType: 1, // 表示放单管理
      businessDataId: this.form.uuid,
      statusValue: CargoDocCfmState.CARGODOC_CONIRMED
    }).save()
    this.statusHistoryConfirmSuccessHandler()
  }
  statusHistoryConfirmSuccessHandler(event) {
    this.getDocCfmState()
  }
  reloadCargoDocHandler() {
    this.changeJob()
    this.fillView()
  }
  /**
   * 完成补料
   */
  async completefeedClickHandler() {
    const newCargoDoc = await SeaImCargoDoc.completeTheFeed(this.form.uuid, this.form.version)
    if (!newCargoDoc) {
      return
    }
    Object.assign(this.form, newCargoDoc)
    await this.completeTheFeedHandler()
  }

  async completeTheFeedHandler() {
    this.job.trackingInfo = ''
    await new SeaImportJob(this.job).getTrackingInfo()
    await this.getCfmBillAddressHandler()
  }
  /**
   * packing changed
   */
  packingChange(data) {
    this.form.packing = data.value
    this.refreshQuantitySum()

    // 包装 不受BillOfLadingSynMode 控制，在其他地方已同步job
    this.job.packing = this.form.packing
    // SeaImCargoDoc.changeSynData(new SeaImportJob(this.job), false, this.form)
  }
  /**
   * quantity changed
   */
  quantityChange() {
    this.refreshQuantitySum()
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  /**
   * weight changed
   */
  weightChange() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  /**
   * cubage changed
   */
  cubageChange() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }

  /**
   * cubage changed
   */
  chargeWeightChange() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }
  otherInfoChangeHandler(value) {
    switch (value) {
      case 'ALSO NOTIFY':
        this.otherField = 'alsoNotify'
        this.view.otherCode = this.form.alsoNotifyCode
        break
      case 'DGCONSIGN':
        this.otherField = 'dgconsign'
        this.view.otherCode = this.form.dgconsignCode
        break
      case 'ELSEINVOICE':
        this.otherField = 'elseInvoice'
        this.view.otherCode = this.form.elseInvoiceCode
        break
    }
  }
  async alsoNotifyAutoCompleteChange(data) {
    if (!data) {
      return
    }
    // 判断是否原数据
    if (data.value === this.view.otherCode || data.value.toUpperCase() === this.view.otherCode) {
      return
    }
    if (data.value) {
      this.view.otherCode = data.value.toUpperCase()
      // 区分下是否手动输入 ，手动输入保留下面数据
      if (data.uuid) {
        this.form.alsoNotify = await CargoDocUtil.alsoNotifyChange(data)
      }
    } else {
      this.view.otherCode = ''
      this.form.alsoNotify = ''
    }
  }
  refreshQuantitySum() {
    const packing = this.packingList.find(p => p.code === this.form.packing)
    this.form.quantitySum = StrUtils.jsdx(this.form.quantity, packing ? packing.name : '')
  }
  /**
   * 合并HBL拆单至Mbl主单
   * @param evt
   */
  mergeHblData() {
    let markHbl = ''
    let eName = ''
    let quantityActual = 0
    let weightActual = 0
    let cubageActual = 0
    if (this.job.seaCargoDoc && this.job.seaCargoDoc.length > 0) {
      // 整合HBL拆单 件毛体 和 英文品名 唛头信息
      const _hblCargoDocs = this.job.seaCargoDoc
      for (const item_hCargoDoc of _hblCargoDocs) {
        if (item_hCargoDoc.docType === CargoDocConsts.HBL2) {
          if (Object.prototype.hasOwnProperty.call(item_hCargoDoc, 'deleted') && item_hCargoDoc.deleted) {
            continue
          }
          if (markHbl) {
            markHbl += '\r'
          }
          markHbl += item_hCargoDoc.mark
          if (eName) {
            eName += '\r'
          }
          eName += item_hCargoDoc.cargoEnglishName
          quantityActual += item_hCargoDoc.quantity
          weightActual += item_hCargoDoc.weight
          cubageActual += item_hCargoDoc.cubage
        }
      }
      // MBL 英文品名 唛头被拆单整合数据覆盖
      for (const item_MCargoDoc of _hblCargoDocs) {
        if (item_MCargoDoc.docType === CargoDocConsts.MBL) {
          item_MCargoDoc.quantity = quantityActual
          item_MCargoDoc.weight = weightActual
          item_MCargoDoc.cubage = cubageActual
          item_MCargoDoc.mark = markHbl
          item_MCargoDoc.cargoEnglishName = eName
        }
      }
      this.form.mark = markHbl
      this.form.cargoEnglishName = eName
      this.form._mergeHblDataTime = new Date()
      // MBL件毛体信息 同步至基本页面件毛体
      this.job.quantityActual = quantityActual
      this.job.weightActual = weightActual
      this.job.cubageActual = cubageActual
    }
    // 多行文本框设为不可输入，随后延时恢复为可输入状态，解决文本框赋值时，光标聚焦在文本框的问题
    this.view.textareaDisabled = true
    setTimeout(() => {
      this.view.textareaDisabled = false
    }, 1)
  }
  /**
   * 放单取回
   */
  async btnGetBackClickHandler() {
    if (this.form.uuid) {
      let params = null
      if (Number(this.form.bliStatus) === CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code) {
        // 撤销取回
        params = {
          bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code,
          getBackDate: '',
          operation: CargoDocCfmState.CARGODOC_CANCEL_GET_BACK,
          isCancel: true
        }
      } else {
        // 取回
        params = {
          bliStatus: CargoDocCfmState.CARGODOC_CFM_STATE_GET_BACKED.code,
          getBackDate: new Date(),
          operation: CargoDocCfmState.CARGODOC_GET_BACK
        }
      }
      const seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], params)
      if (seaCargoDoc && seaCargoDoc.length > 0) {
        Object.assign(this.form, seaCargoDoc[0])
      }
      this.saveReleaseStateStateHandler()
    }
  }
  /**
   * 放单撤销
   */
  async btnReleasingClickHandler(event) {
    if (this.form.uuid && this.form.cfmState === CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code) {
      // 撤销放单
      const obj = {}
      obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_WKS.code
      obj.releaseDate = ''
      obj.operation = CargoDocCfmState.CARGODOC_CANCEL_RETURN
      obj.surrenderedNo = ''
      obj.releaseState = CargoDocCfmState.CARGODOC_CAN_SINGLE_RELEASE
      obj.releaseBy = 0

      this.job.seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], obj)
      this.saveReleaseStateStateHandler()
    } else if (this.form.uuid && this.form.releaseState === ReleaseState.SINGLERELEASE.code) {
      // 放单
      this.view.$prompt('放单号:', this.view.$t('SeaExport.EnterReleaseNumber'), {
        confirmButtonText: this.view.$t('Invoice.invoice_confirm'),
        cancelButtonText: this.view.$t('Message.Cancel')
      }).then(async value => {
        await this.commitSurrenderedNoHandler(value)
      }).catch(() => { })
    }
  }
  async commitSurrenderedNoHandler(value) {
    const obj = {}
    obj.cfmState = CargoDocCfmState.CARGODOC_CFM_STATE_RELEASED.code
    obj.releaseDate = new Date()
    obj.operation = CargoDocCfmState.CARGODOC_RETURN
    obj.surrenderedNo = value
    this.job.seaCargoDoc = await SeaImCargoDoc.updateProperties([this.form.uuid], obj)
    this.saveReleaseStateStateHandler()
  }
  saveReleaseStateStateHandler(e) {
    this.view.$message.success(this.view.$t('SeaExport.StatusModefySuccessfully'))
    this.loadCargoDoc2Handler()
  }
  carrierIsOpenMscEDI() {
    this.isCarrierUserMSC = false
    if (this.useMscEDICarriers) {
      const useMscEDICarrierArr = this.useMscEDICarriers.split(',')
      const carrier = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
      const scac = carrier ? carrier.scac : ''
      if (scac && scac.length > 0) {
        for (const s of useMscEDICarrierArr) {
          if (s.indexOf(scac) >= 0 && s.indexOf('1') >= 0) {
            this.isCarrierUserMSC = true
            break
          }
        }
      }
    }
  }
  showScac() {
    const company = this.context.companyList.find(p => p.cmpIdx === this.job.carrierId)
    this.view.txtCarrierScAc = company ? company.scac : ''
    const company1 = this.context.companyList.find(p => p.cmpIdx === this.job.destinationAgent)
    this.view.txtBookingAgentScAc = company1 ? company1.scac : ''
  }
  getDocCfmState() {
    const isZh = this.view.$i18n.locale === 'zh'
    const releaseState = ReleaseState.getReleaseStateByCode(this.form.releaseState)
    if (releaseState) {
      this.view.lblReleaseState = isZh ? releaseState.chineseName : releaseState.englishName
    }
  }
  refreshVessel() {
    if (this.job.barge && this.form.printParam6) {
      this.view.txtFirstVesselVoyage = this.job.bargeVessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.bargeVoyage || ''
    } else {
      this.view.txtFirstVesselVoyage = this.job.vessel || ''
      this.view.txtFirstVesselVoyage += ' '
      this.view.txtFirstVesselVoyage += this.job.voyageFlight || ''
    }
  }
  // 同步基本页签的收货地，起运港(POL)，卸货港(POD)，交货地，主单付款地点 到MBL页签的 提单发货地，提单起运港，提单卸货港，提单交货地，MBL付款地点
  async initPortCode() {
    this.form.dispatchingPlace = this.job.dispatchingPlace
    this.form.loadingPort = await this.getPortCodeEnglishName(this.job.loadingPortCode)
    this.form.dischargingPort = await this.getPortCodeEnglishName(this.job.dischargingPortCode)
    this.form.destinationPort = this.job.destinationPlace
    this.form.paymentPlaceBL = this.job.paymentPlaceMbl
    this.refreshVessel()
  }
  async getPortCodeEnglishName(portCode) {
    if (!portCode) return ''
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const selPort = seaPorts.filter(p => p.code === portCode)
    if (selPort && selPort.length > 0) {
      return selPort[0].englishName
    }
    return ''
  }
  /**
 * is editing
 */
  async editingChanged() {
    await this.loadJointSlaves2Handler()
  }
  /**
 * 投保
 */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      docUuid: this.form.uuid,
      billno: this.job.mbl,
      insureType: 'DOC'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
    // if (Number(this.config.get('isPlatformInsurance')) === 3) {
    //   const payload = {
    //     jobUuid: this.job.uuid,
    //     branchId: $store.getters.currentOfficeId,
    //     docUuid: this.form.uuid,
    //     billno: this.job.mbl,
    //     insureType: 'DOC'
    //   }
    //   const continueExec = await JobUtils.openInsure(payload, this.view)
    //   if (continueExec) {
    //     // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
    //     this.view.$router.push({
    //       name: 'ToInsurePage',
    //       query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
    //       params: { insureForm: payload }
    //     })
    //   }
    //   return
    // }
    // if (this.config.get('BurialPointMode') === 'on') {
    //   // LogStores.sendFunctionClickLogStoresByLabel('MBL-投保')
    // }
    // if (this.view.$checkPermission(['button_insurance_toInsure'])) {
    //   let mbl = null
    //   for (const doc of this.job.seaCargoDoc) {
    //     if (doc.docType === 'MBL') {
    //       mbl = doc
    //       break
    //     }
    //   }
    //   // todo-shengsheng  Desc: why?
    //   // if (Object.prototype.hasOwnProperty.call(this.job, 'containerUsages')) {
    //   //   for (const usage of this.job.containerUsages) {
    //   //     delete usage.container
    //   //   }
    //   // }
    //   // if (Object.prototype.hasOwnProperty.call(this.job, 'containers')) {
    //   //   for (const container of this.job.containers) {
    //   //     delete container.containerUsages
    //   //   }
    //   // }
    //   SeaImCargoDoc.toInsure(this.user.tenantName, mbl, this.job, this.context.office).then(data => {
    //     this.insureSuccessHandler(data)
    //   })
    // } else {
    //   this.view.$message.warning(this.view.$t('SeaExport.NotInsuranceOperationPermission'))
    // }
  }
  /**
  * 投保成功
  */
  // insureSuccessHandler(data) {
  //   const result = data.result
  //   const status = data.status
  //   if (status === 'true') {
  //     window.open(result, '_blank', 'noreferrer')
  //   } else {
  //     this.view.$message.warning(result)
  //   }
  // }
  /**
 * 投保按钮点击成功 日志
 * @param event
 */
  sendInsureClickLogStoresHandler(event) {
  }
  /**
 * 发货人选择
 */
  async shipperAutoCompleteChange(data) {
    this.form.shipperId = data.value
    // SeaImCargoDoc.syncSCN(view.job,syncSCNCode,"shipper",1); //
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.syncSCNCode, 'shipper', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyShipperManifestAddress(data)
  }
  applyShipperManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.shipperCode = company.englishName
      this.form.shipperLine1 = manifestaddress.addressLine1
      this.form.shipperLine2 = manifestaddress.addressLine2
      this.form.shipperLine3 = manifestaddress.addressLine3
      this.form.shipperLine4 = manifestaddress.addressLine4
      this.form.shipperLine5 = manifestaddress.addressLine5
      this.form.shipperLine6 = manifestaddress.addressLine6
      this.form.shipperLine7 = manifestaddress.addressLine7
    } else {
      this.form.shipperCode = ''
      this.form.shipperLine1 = ''
      this.form.shipperLine2 = ''
      this.form.shipperLine3 = ''
      this.form.shipperLine4 = ''
      this.form.shipperLine5 = ''
      this.form.shipperLine6 = ''
      this.form.shipperLine7 = ''
    }
  }
  /**
 * 收货人选择
 */
  async consigneeAutoCompleteChange(data) {
    this.form.consigneeId = data.value
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'consignee', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyConsigneeManifestAddress(data)
  }
  applyConsigneeManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.consigneeCode = company.englishName
      this.form.consigneeLine1 = manifestaddress.addressLine1
      this.form.consigneeLine2 = manifestaddress.addressLine2
      this.form.consigneeLine3 = manifestaddress.addressLine3
      this.form.consigneeLine4 = manifestaddress.addressLine4
      this.form.consigneeLine5 = manifestaddress.addressLine5
      this.form.consigneeLine6 = manifestaddress.addressLine6
      this.form.consigneeLine7 = manifestaddress.addressLine7
    } else {
      this.form.consigneeCode = ''
      this.form.consigneeLine1 = ''
      this.form.consigneeLine2 = ''
      this.form.consigneeLine3 = ''
      this.form.consigneeLine4 = ''
      this.form.consigneeLine5 = ''
      this.form.consigneeLine6 = ''
      this.form.consigneeLine7 = ''
    }
  }
  /**
 * 通知人选择
 */
  async notifyAutoCompleteChange(data) {
    this.form.notifyId = data.value
    JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode, 'notify', 1)
    const company = new Company(data)
    await company.getMainfestAddress()
    this.applyNotifyManifestAddress(data)
  }
  applyNotifyManifestAddress(company) {
    const manifestaddress = company.manifestAddress
    if (manifestaddress) {
      this.form.notifyCode = company.englishName
      this.form.notifyLine1 = manifestaddress.addressLine1
      this.form.notifyLine2 = manifestaddress.addressLine2
      this.form.notifyLine3 = manifestaddress.addressLine3
      this.form.notifyLine4 = manifestaddress.addressLine4
      this.form.notifyLine5 = manifestaddress.addressLine5
      this.form.notifyLine6 = manifestaddress.addressLine6
      this.form.notifyLine7 = manifestaddress.addressLine7
    } else {
      this.form.notifyCode = ''
      this.form.notifyLine1 = ''
      this.form.notifyLine2 = ''
      this.form.notifyLine3 = ''
      this.form.notifyLine4 = ''
      this.form.notifyLine5 = ''
      this.form.notifyLine6 = ''
      this.form.notifyLine7 = ''
    }
  }
  async txtChargeWeightHandler() {
    await new SeaImportJob(this.job).getCargoDocByDocType(CargoDocConsts.HBL, false)
    await SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), false, this.form)
  }
}
